<div *ngIf="loading" class="loading">
    <mat-spinner mode="indeterminate"></mat-spinner>
</div>
<div *ngIf="!loading" class="field-correction-wrapper" [class.rtl]="currLang == 'ar'">
    <div class="header">
        <span class="title">{{'user-management.upload.fix-data' | translate}}</span>
        <button id="button-a" (click)="exportToExcelFile()" class="btn btn-outline-primary download-btn">
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.375 11.5625V13.3438C1.375 13.8162 1.56267 14.2692 1.89672 14.6033C2.23077 14.9373 2.68383 15.125 3.15625 15.125H13.8438C14.3162 15.125 14.7692 14.9373 15.1033 14.6033C15.4373 14.2692 15.625 13.8162 15.625 13.3438V11.5625M12.0625 8L8.5 11.5625M8.5 11.5625L4.9375 8M8.5 11.5625V0.875"
                    stroke="#0074EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{'field-correction-revamp.download' | translate}}
        </button>

    </div>
    <div class="body">
        <div class="card-info-section">
            <div class="header">
                <span class="title"> {{'field-correction-revamp.missing-data' | translate}}</span>
                <div class="progress-wrapper">
                    <div class="percentage">{{progressLocalization(progress)}}%</div>
                    <mat-progress-bar *ngIf="progress !== undefined" mode="determinate" [value]="progress">
                    </mat-progress-bar>
                </div>
            </div>
            <div class="body">
                <div class="cards-wrapper">
                    <div class="card-info" *ngFor="let infoCard of fileErrors, index as rowIndex "
                        (click)="selectError(infoCard , false)" [class.selected]="infoCard?.selected">
                        <span class="name">{{userRole == 'students'? ('field-correction-revamp.student-name' | translate
                            ):('field-correction-revamp.staff-name' | translate)}} : {{infoCard?.values?.name}} </span>
                        <span class="name" *ngIf="userRole == 'students'"> {{'field-correction-revamp.parent-name' |
                            translate}} : {{infoCard?.values?.parent_name}} </span>
                        <!-- <span>{{infoCard?.selected}}</span> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="card-details-section">
            <div class="error-wrapper" *ngFor="let error of fileErrors, index as errorIndex ">
                <div class="error-content" *ngIf="error.selected">
                    <div class="header">
                        <button class="skip-error-btn" (click)="skipError(error, errorIndex)">
                            {{ 'field-correction-revamp.skip-error' | translate }}
                        </button>
                        <button (click)="selectError(error , true)">
                            {{fileErrors.length == 1 ? ('field-correction-revamp.save' | translate
                            ):('field-correction-revamp.save-and-next' | translate)}}
                        </button>
                    </div>
                    <div class="body">
                        <div class="parent-section" *ngIf="userRole == 'students'">
                            <div class="title">
                                {{'field-correction-revamp.parent-details' | translate}}
                            </div>
                            <!-- parent name -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('parent.name')">{{'user-management.upload.upload-fields.parent-name'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('parent.name')"
                                    [(ngModel)]="error.values.parent_name">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('parent.name')"
                                    *ngIf="error?.fileErrorKeys.includes('parent.name') ? true : false">
                                    {{error.invalid['parent.name'][0]}}
                                </span>
                            </div>
                            <!-- parent national id -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('parent.national_id')">{{'user-management.upload.upload-fields.parent-national-id'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('parent.national_id')"
                                    [(ngModel)]="error.values.parent_national_id" data-pii="redact">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('parent.national_id')"
                                    *ngIf="error?.fileErrorKeys.includes('parent.national_id') ? true : false">
                                    {{error.invalid['parent.national_id'][0]}}
                                </span>
                            </div>
                            <!-- parent gender -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('parent.gender')">{{'user-management.upload.upload-fields.parent-gender'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('parent.gender')"
                                    [(ngModel)]="error.values.parent_gender">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('parent.gender')"
                                    *ngIf="error?.fileErrorKeys.includes('parent.gender') ? true : false">
                                    {{error.invalid['parent.gender'][0]}}
                                </span>
                            </div>
                            <!-- parent email -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('parent.email')">{{'user-management.upload.upload-fields.parent-email'
                                    | translate}}</span>

                                <!-- field -->
                                <input dir="ltr" [class.inputError]="error?.fileErrorKeys.includes('parent.email')"
                                    [(ngModel)]="error.values.parent_email">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('parent.email')"
                                    *ngIf="error?.fileErrorKeys.includes('parent.email') ? true : false">
                                    {{error.invalid['parent.email'][0]}}
                                </span>
                            </div>
                            <!-- parent country code -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('parent.country_code')">{{'user-management.upload.upload-fields.code'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('parent.country_code')"
                                    [(ngModel)]="error.values.parent_country_code">

                                <!-- errormsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('parent.country_code')"
                                    *ngIf="error?.fileErrorKeys.includes('parent.country_code') ? true : false">
                                    {{error.invalid['parent.country_code'][0]}}
                                </span>
                            </div>
                            <!-- parent phone -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('parent.phone')">{{'user-management.upload.upload-fields.phone'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('parent.phone')"
                                    [(ngModel)]="error.values.parent_phone" data-pii="redact">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('parent.phone')"
                                    *ngIf="error?.fileErrorKeys.includes('parent.phone') ? true : false">
                                    {{error.invalid['parent.phone'][0]}}
                                </span>
                            </div>
                        </div>
                        <div class="student-section" *ngIf="userRole == 'students'">
                            <div class="title">
                                {{'field-correction-revamp.student-details' | translate}}
                            </div>
                            <!-- student name  -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('name')">{{'user-management.upload.upload-fields.student-name'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('name')"
                                    [(ngModel)]="error.values.name">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('name')"
                                    *ngIf="error?.fileErrorKeys.includes('name') ? true : false">
                                    {{error.invalid['name'][0]}}
                                </span>
                            </div>
                            <!-- student national_id -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('national_id')">{{'user-management.upload.upload-fields.student-national-id'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('national_id')"
                                    [(ngModel)]="error.values.national_id" data-pii="redact">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('national_id')"
                                    *ngIf="error?.fileErrorKeys.includes('national_id') ? true : false">
                                    {{error.invalid['national_id'][0]}}
                                </span>
                            </div>
                            <!-- studnet gender -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('gender')">{{'user-management.upload.upload-fields.student-gender'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('gender')"
                                    [(ngModel)]="error.values.gender">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('gender')"
                                    *ngIf="error?.fileErrorKeys.includes('gender') ? true : false">
                                    {{error?.invalid?.gender[0]}}
                                </span>
                            </div>
                            <!-- create grades and classes -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('create_grade_and_class')">{{'user-management.upload.upload-fields.create-grade-and-class'
                                    | translate}}</span>

                                <!-- field -->
                                <!-- <input *ngIf="!error?.fileErrorKeys.includes('create_grade_and_class')"
                                    [class.inputError]="error?.fileErrorKeys.includes('create_grade_and_class')"
                                    [(ngModel)]="error.values.create_grade_and_class" disabled> -->

                                <select [class.inputError]="error?.fileErrorKeys.includes('create_grade_and_class')"
                                    [(ngModel)]="error.values.create_grade_and_class">
                                    <option disabled
                                        *ngIf="error.values.create_grade_and_class !='yes' && error.values.create_grade_and_class !='no' "
                                        [value]="error.values.create_grade_and_class">
                                        {{error.values.create_grade_and_class}}</option>
                                    <option value="yes">{{'field-correction-revamp.yes' | translate}}</option>
                                    <option value="no">{{'field-correction-revamp.no' | translate}}</option>
                                </select>

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('create_grade_and_class')"
                                    *ngIf="error?.fileErrorKeys.includes('create_grade_and_class') ? true : false">
                                    {{error?.invalid?.create_grade_and_class[0]}}
                                </span>
                            </div>
                            <!-- Grade -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('grade_name')">{{'user-management.upload.upload-fields.grade'
                                    | translate}}</span>

                                <!-- field -->
                                <input *ngIf="!switchGradesDropdown"
                                    [class.inputError]="error?.fileErrorKeys.includes('grade_name')"
                                    [(ngModel)]="error.values.grade_name">
                                <select *ngIf="switchGradesDropdown" (change)="setGrade()"
                                    [(ngModel)]="selectedGradeindex">
                                    <option [value]="in" *ngFor="let grade of grades, index as in">{{grade.name}}
                                    </option>
                                </select>

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('grade_name')"
                                    *ngIf="error?.fileErrorKeys.includes('grade_name') ? true : false">
                                    {{error?.invalid?.grade_name[0]}}
                                </span>

                                <!-- reselect-btn -->
                                <button class=" swap-drop"
                                    *ngIf="error?.fileErrorKeys.includes('class_name') || error?.fileErrorKeys.includes('grade_name')"
                                    (click)="reselectGradesClasses()">{{'user-management.upload.upload-fields.reselect-btn'
                                    | translate}}</button>
                            </div>
                            <!-- class -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('class_name')">{{'user-management.upload.upload-fields.class'
                                    | translate}}</span>

                                <!-- field -->
                                <input *ngIf="!switchGradesDropdown"
                                    [class.inputError]="error?.fileErrorKeys.includes('class_name')"
                                    [(ngModel)]="error.values.class_name">
                                <select *ngIf="switchGradesDropdown" [(ngModel)]="selectedClassId">
                                    <option [value]="class.id"
                                        *ngFor="let class of grades[selectedGradeindex].school_classes">{{class.name}}
                                    </option>
                                </select>

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('class_name')"
                                    *ngIf="error?.fileErrorKeys.includes('class_name') ? true : false">
                                    {{error?.invalid?.class_name[0]}}
                                </span>
                            </div>
                        </div>

                        <div class="staff-section" *ngIf="userRole == 'staff'">
                            <div class="title">
                                {{'field-correction-revamp.staff-details' | translate}}
                            </div>
                            <!-- shared staff account mismatch (A2): the row fails as a whole, no single field to blame -->
                            <div class="error-row" *ngIf="error?.fileErrorKeys.includes('staff_account')">
                                <span class="label error">{{'field-correction-revamp.staff-account' | translate}}</span>
                                <span class="error">{{error?.invalid?.staff_account[0]}}</span>
                            </div>
                            <!-- staff name  -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('name')">{{'user-management.upload.upload-fields.staff-name'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('name')"
                                    [(ngModel)]="error.values.name">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('name')"
                                    *ngIf="error?.fileErrorKeys.includes('name') ? true : false">
                                    {{error.invalid['name'][0]}}
                                </span>
                            </div>
                            <!-- staff national_id -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('national_id')">{{'user-management.upload.upload-fields.staff-national-id'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('national_id')"
                                    [(ngModel)]="error.values.national_id" data-pii="redact">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('national_id')"
                                    *ngIf="error?.fileErrorKeys.includes('national_id') ? true : false">
                                    {{error.invalid['national_id'][0]}}
                                </span>
                            </div>
                            <!-- staff gender -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('gender')">{{'user-management.upload.upload-fields.staff-gender'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('gender')"
                                    [(ngModel)]="error.values.gender">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('gender')"
                                    *ngIf="error?.fileErrorKeys.includes('gender') ? true : false">
                                    {{error?.invalid?.gender[0]}}
                                </span>
                            </div>

                            <!-- staff email -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('email')">{{'user-management.upload.upload-fields.staff-email'
                                    | translate}}</span>

                                <!-- field -->
                                <input dir="ltr" [class.inputError]="error?.fileErrorKeys.includes('email')"
                                    [(ngModel)]="error.values.email">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('email')"
                                    *ngIf="error?.fileErrorKeys.includes('email') ? true : false">
                                    {{error.invalid['email'][0]}}
                                </span>
                            </div>

                            <!-- staff country code -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('country_code')">{{'user-management.upload.upload-fields.staff-country-code'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('country_code')"
                                    [(ngModel)]="error.values.country_code">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('country_code')"
                                    *ngIf="error?.fileErrorKeys.includes('country_code') ? true : false">
                                    {{error?.invalid?.country_code[0]}}
                                </span>
                            </div>

                            <!-- staff phone -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('phone')">{{'user-management.upload.upload-fields.staff-phone'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('phone')"
                                    [(ngModel)]="error.values.phone" data-pii="redact">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('phone')"
                                    *ngIf="error?.fileErrorKeys.includes('phone') ? true : false">
                                    {{error?.invalid?.phone[0]}}
                                </span>
                            </div>

                            <!-- staff role -->
                            <div class="error-row">
                                <!-- label -->
                                <span class="label"
                                    [class.error]="error?.fileErrorKeys.includes('role_type')">{{'user-management.upload.upload-fields.role-type'
                                    | translate}}</span>

                                <!-- field -->
                                <input [class.inputError]="error?.fileErrorKeys.includes('role_type')"
                                    [(ngModel)]="error.values.role_type">

                                <!-- errorMsg -->
                                <span [class.error]="error?.fileErrorKeys.includes('role_type')"
                                    *ngIf="error?.fileErrorKeys.includes('role_type') ? true : false">
                                    {{error?.invalid?.role_type[0]}}
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Confirmation Modal for Skipped Errors -->
<div class="download-confirmation-modal-backdrop" id="fieldCorrectionConfirmationModal" *ngIf="showConfirmationModal">
    <div class="download-confirmation-modal">
        <div class="hint">
            {{'user-management.upload.confirmation-skipped-hint' |translate}}
        </div>
        <div class="modal-actions">
            <button class="skip-btn"
                (click)="cancelAndHideComponent()">{{'user-management.upload.skip-btn'
                |translate}}</button>
            <button class="download-skipped-errors-btn"
                (click)="downloadSkippedErrors()">{{'user-management.upload.download-btn'
                |translate}}</button>
        </div>
    </div>
</div>

<app-error-msg></app-error-msg>